module.exports = __webpack_public_path__ + "static/media/report_2.d5c66ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/report_2.jpg
// module id = 412
// module chunks = 0